import firebase from "firebase";
import "firebase/firestore";

import store from "./store";


const firebaseConfig = {
  apiKey: "AIzaSyBinYa3Y83-J0fvzRJ344eRCapXPLfpaKA",
  authDomain: "popshap-resellers.firebaseapp.com",
  databaseURL: "https://popshap-resellers.firebaseio.com",
  projectId: "popshap-resellers",
  storageBucket: "popshap-resellers.appspot.com",
  messagingSenderId: "577632201550",
  appId: "1:577632201550:web:b39af57998e77d09d90c1f"
}

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const storage = firebaseApp.storage();
const fieldValue = firebase.firestore.FieldValue;
const auth = firebase.auth();
const functions = firebase.functions();
const currentUser = auth.currentUser;
// const googleProvider = new firebase.auth.GoogleAuthProvider();
// const facebookProvider = new firebase.auth.FacebookAuthProvider();

// date issue fix according to firebase
const settings = {};
db.settings(settings);

//When ever the user authentication state changes write the user to vuex.

export default {
  db,
  auth,
  functions,
  currentUser,
  fieldValue,
  storage,
  // googleProvider,
  // facebookProvider,
};
